import { IShiftProgramResponse } from 'types/api/operationsShiftProgramsApi.interface'

const hoursAgo = (h: number) => new Date(Date.now() - h * 3600000).toISOString()
const daysAgo = (d: number) => hoursAgo(d * 24)

const nextShiftStart = () => {
  const now = new Date()
  const next = new Date(now)
  next.setMinutes(0, 0, 0)
  if (now.getHours() < 6) {
    next.setHours(6)
  } else if (now.getHours() < 18) {
    next.setHours(18)
  } else {
    next.setDate(next.getDate() + 1)
    next.setHours(6)
  }
  return next.toISOString()
}

const nextMondayMorning = () => {
  const next = new Date()
  next.setHours(6, 0, 0, 0)
  const daysUntilMonday = (8 - next.getDay()) % 7 || 7
  next.setDate(next.getDate() + daysUntilMonday)
  return next.toISOString()
}

const inDaysAt = (days: number, hour: number) => {
  const next = new Date()
  next.setDate(next.getDate() + days)
  next.setHours(hour, 0, 0, 0)
  return next.toISOString()
}

const todayAt = (hour: number, minute: number) => {
  const date = new Date()
  date.setHours(hour, minute, 0, 0)
  return date.toISOString()
}

const yesterdayAt = (hour: number, minute: number) => {
  const date = new Date()
  date.setDate(date.getDate() - 1)
  date.setHours(hour, minute, 0, 0)
  return date.toISOString()
}

const lastMondayMorning = () => {
  const date = new Date(nextMondayMorning())
  date.setDate(date.getDate() - 7)
  return date.toISOString()
}

export const DEMO_SHIFT_PROGRAMS: IShiftProgramResponse[] = [
  {
    id: 80001,
    name: 'Daily Equipment Inspection',
    notes: 'Pre-shift checks on all heavy mining equipment',
    site: { id: 1, name: 'North Pit' },
    teams: [{ id: 1, name: 'Maintenance', type: 1 }],
    recurrenceType: 2,
    frequencyType: 'DAILY',
    weeklyDays: [],
    daysOfWeek: [],
    customIntervalDays: 0,
    shifts: [{ id: 1, name: 'Day' }, { id: 2, name: 'Night' }],
    status: 1,
    nextRunAt: nextShiftStart(),
    lastRunAt: todayAt(6, 10),
    lastRunStatus: 1,
    bindings: [],
    createdAt: daysAgo(31),
    updatedAt: hoursAgo(6),
  },
  {
    id: 80002,
    name: 'Pre-Shift Safety Walk',
    notes: 'Walk the active faces and check controls before each shift',
    site: { id: 2, name: 'Block B' },
    teams: [{ id: 2, name: 'HSE', type: 1 }],
    recurrenceType: 1,
    frequencyType: 'EVERY_SHIFT',
    weeklyDays: [],
    daysOfWeek: [],
    customIntervalDays: 0,
    shifts: [{ id: 1, name: 'Day' }, { id: 2, name: 'Afternoon' }, { id: 3, name: 'Night' }],
    status: 1,
    nextRunAt: nextShiftStart(),
    lastRunAt: todayAt(6, 5),
    lastRunStatus: 1,
    bindings: [],
    createdAt: daysAgo(30),
    updatedAt: hoursAgo(7),
  },
  {
    id: 80003,
    name: 'Weekly Conveyor Inspection',
    notes: 'Full inspection of CV-1 to CV-3 idlers and splices',
    site: { id: 4, name: 'Processing Plant' },
    teams: [{ id: 1, name: 'Maintenance', type: 1 }],
    recurrenceType: 3,
    frequencyType: 'WEEKLY',
    weeklyDays: [1],
    daysOfWeek: [1],
    customIntervalDays: 0,
    shifts: [{ id: 1, name: 'Day' }],
    status: 1,
    nextRunAt: nextMondayMorning(),
    lastRunAt: lastMondayMorning(),
    lastRunStatus: 1,
    bindings: [],
    createdAt: daysAgo(29),
    updatedAt: daysAgo(2),
  },
  {
    id: 80004,
    name: 'Ventilation System Check',
    notes: 'Underground airflow and gas monitoring',
    site: { id: 6, name: 'Underground' },
    teams: [{ id: 3, name: 'Ventilation', type: 1 }],
    recurrenceType: 2,
    frequencyType: 'DAILY',
    weeklyDays: [],
    daysOfWeek: [],
    customIntervalDays: 0,
    shifts: [{ id: 1, name: 'Day' }, { id: 3, name: 'Night' }],
    status: 2,
    nextRunAt: nextShiftStart(),
    lastRunAt: yesterdayAt(18, 0),
    lastRunStatus: 2,
    bindings: [],
    createdAt: daysAgo(28),
    updatedAt: daysAgo(3),
  },
  {
    id: 80005,
    name: 'Pump Station Inspection',
    notes: 'Check dewatering pumps, seals and flow rates',
    site: { id: 5, name: 'South Sump' },
    teams: [{ id: 1, name: 'Maintenance', type: 1 }],
    recurrenceType: 4,
    frequencyType: 'CUSTOM',
    weeklyDays: [],
    daysOfWeek: [],
    customIntervalDays: 3,
    shifts: [{ id: 1, name: 'Day' }],
    status: 1,
    nextRunAt: inDaysAt(2, 9),
    bindings: [],
    createdAt: daysAgo(27),
    updatedAt: daysAgo(1),
  },
  {
    id: 80006,
    name: 'Haul Truck Pre-Op Inspection',
    notes: 'Operator pre-operation checklist for haul fleet',
    site: { id: 3, name: 'Haul Road 3' },
    teams: [{ id: 4, name: 'Haulage', type: 1 }],
    recurrenceType: 1,
    frequencyType: 'EVERY_SHIFT',
    weeklyDays: [],
    daysOfWeek: [],
    customIntervalDays: 0,
    shifts: [{ id: 1, name: 'Day' }, { id: 2, name: 'Afternoon' }, { id: 3, name: 'Night' }],
    status: 1,
    nextRunAt: nextShiftStart(),
    lastRunAt: todayAt(6, 0),
    lastRunStatus: 3,
    bindings: [],
    createdAt: daysAgo(26),
    updatedAt: hoursAgo(6),
  },
  {
    id: 80007,
    name: 'Camp Cleaning',
    notes: 'Daily housekeeping of camp accommodation and mess areas',
    site: { id: 7, name: 'Camp' },
    teams: [{ id: 5, name: 'Camp Services', type: 1 }],
    recurrenceType: 2,
    frequencyType: 'DAILY',
    weeklyDays: [],
    daysOfWeek: [],
    customIntervalDays: 0,
    shifts: [{ id: 1, name: 'Day' }],
    status: 1,
    nextRunAt: nextShiftStart(),
    lastRunAt: todayAt(6, 10),
    lastRunStatus: 1,
    bindings: [],
    createdAt: daysAgo(25),
    updatedAt: hoursAgo(9),
  },
]
